package nl.volleyplanner.api.entities

import kotlinx.serialization.Serializable
import nl.volleyplanner.api.types.PublicDataPayload

@Serializable
data class GroupListResponse(
    val groups: List<Group>
)

@Serializable
data class Group(
    val id: String,
    val type: String,
    val name: String,
    val memberIds: List<String>?
) : PublicDataPayload